import {ajax} from "../utils";
import Modal from "../frontv2/Modal";
import InputNumber from "../frontv2/InputNumber";
import BookingProcess from "../embed/BookingProcess";
import intlTelInput from 'intl-tel-input';
import {initStripe} from "../stripe";
import Message from "../Message";
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';
import { initCountDown, clearAllReservedSpotsCountdowns } from "../countdown";
import Dob from "../common/Dob";
import { initDrops } from "../common/drop";
import { initSeeMoreContent } from "../frontv2/seeMoreContent";
import ReviewsFiltering from "../frontv2/ReviewsFiltering";
import { initSwiper } from "../common/init-swiper";
import { initMelchiorInput } from "../common/init-melchior-input";
import { scrollEmbedBookingLayoutToTop } from "../embed/scrollEmbedBookingLayoutToTop";

/**
 * Add loading-modal class and tiny-spinner on mobile/tablet
 * @param {Element} element - The element to add classes to
 */
function addLoadingModal(element) {
  if(!element) return;

  element.classList.add('loading-modal');
  if (window.matchMedia('(max-width: 1024px)').matches) {
    element.classList.add('tiny-spinner');
  }
}

/**
 * Reveal the modal content with a fade animation
 * @param {Element} modalRoot - The modal root element
 */
function revealEmbedModalContent(modalRoot) {
  const modalContent = modalRoot.querySelector('.modal-content');
  if (!modalContent) {
    return;
  }

  const modalContainer = modalRoot.querySelector('.modal-container');
  if (modalContainer) {
    modalContainer.scrollTop = 0;
  }
  modalContent.scrollTop = 0;

  document.querySelectorAll('.modal-content.modal-content-fade-visible').forEach((el) => {
    if (el !== modalContent) {
      el.classList.remove('modal-content-fade-visible');
    }
  });

  window.setTimeout(() => {
    modalContent.classList.add('modal-content-fade-visible');
  }, 350);
}

/** Stored handler so we never stack duplicate listeners when reopening booking without checkout */
const BOOKING_MODAL_PAYMENT_CLICK_KEY = '_winalistBookingPaymentClick';

function detachBookingModalPaymentClick(bookingModalEl) {
  if (!bookingModalEl) return;
  const prev = bookingModalEl[BOOKING_MODAL_PAYMENT_CLICK_KEY];
  if (prev) {
    bookingModalEl.removeEventListener('click', prev);
    bookingModalEl[BOOKING_MODAL_PAYMENT_CLICK_KEY] = null;
  }
}

// function resetCheckoutModalWidths() {
//   // make sure to reset the max width of previous checkout/free modal states
//   const modalsContainers = document.querySelectorAll('#payment-modal .modal-container, #payment-modal .modal-content, #free-modal .modal-container, #free-modal .modal-content');
//   if(modalsContainers){
//     modalsContainers.forEach(container => {
//       container.classList.remove('max-w-2xl');
//     });
//   }
// }

const initWidgetBookingModals = () => {
  const detailModal = document.getElementById('detail-modal');
  const bookingModal = document.getElementById('booking-modal');
  const paymentModal = document.getElementById('payment-modal');
  const freeModal = document.getElementById('free-modal');
  const widgetWrapper = document.getElementById('widgetWrapper');
  const bookButtons = document.querySelectorAll('button[data-open-booking], button[data-open-detail]');

  // Observe body class changes to enable booking buttons when modal closes
  function enableAllBookingButtons() {
    bookButtons.forEach(button => {
      button.disabled = false;
      button.classList.remove('loading');
    });
  }

  if (window.MutationObserver) {
    const bodyObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const body = document.body;
          // When modal-active class is removed, enable all booking buttons
          if (!body.classList.contains('modal-active')) {
            enableAllBookingButtons();
          }
        }
      });
    });

    bodyObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  function loadDetailModal(experienceId, button) {
    ajax('/embed/detail/' + experienceId + '?currency=' + widgetWrapper?.dataset.currencyIso + '&locale=' + widgetWrapper?.dataset.locale, function(data) {
      const detailContent = detailModal.querySelector('.modal-content');
      detailContent.classList.remove('modal-content-fade-visible');
      detailContent.innerHTML = data;
      detailModal.querySelector('.modal-container').classList.remove('loading-modal');
      const closeModalTriggers = detailModal.querySelectorAll('.modal-content .modal-close');
      if(closeModalTriggers){
        closeModalTriggers.forEach((trigger) => {
          trigger.addEventListener('click', Modal.closeAllModals);
        });
      }

      // detailModal.querySelector('.modal-content .modal-close').addEventListener('click', Modal.closeAllModals);
      Modal.toggleModal('#detail-modal');
      revealEmbedModalContent(detailModal);

      const openBookButton = detailModal.querySelectorAll('button[data-open-book]');
      openBookButton.forEach((button) => {
        button.addEventListener('click', function() {
          addLoadingModal(detailModal.querySelector('.modal-container'));
          loadBookingModal(button.dataset.experienceId);
        });
      });

      button.classList.remove('loading');
      enableAllBookingButtons();

      let backToExperiencesList = document.querySelectorAll('.close-modal');
      if(backToExperiencesList){}
      for (let i = 0; i < backToExperiencesList.length; i++) {
        backToExperiencesList[i].addEventListener('click', Modal.closeAllModals);
      }

      initSeeMoreContent();
      initSwiper(detailModal);

      new ReviewsFiltering();

      // resetCheckoutModalWidths();

      tippy('[data-tippy-content]', {
        theme: 'light'
      });
    },  'GET', {}, {}, true, false);
  }

  function loadBookingModal(experienceId) {
    detachBookingModalPaymentClick(bookingModal);

    ajax('/embed/booking/' + experienceId + '?currency=' + widgetWrapper?.dataset.currencyIso + '&locale=' + widgetWrapper?.dataset.locale, function(data) {
      const bookingContent = bookingModal.querySelector('.modal-content');
      bookingContent.classList.remove('modal-content-fade-visible');
      bookingContent.innerHTML = data;
      bookingModal.querySelector('.modal-container').classList.remove('loading-modal');
      Modal.closeAllModals();

      const closeButton = bookingModal.querySelector('.modal-content .modal-close');
      if(closeButton){
        closeButton.addEventListener('click', Modal.closeAllModals);
      }

      const allInputNumber = bookingModal.querySelectorAll('div.input-number');
      if (allInputNumber.length > 0) {
        allInputNumber.forEach((wrapperInputNumber) => {
          new InputNumber(wrapperInputNumber);
        });
      }

      initDrops(bookingModal);
      new BookingProcess();
      // resetCheckoutModalWidths();
      Modal.toggleModal('#booking-modal');
      revealEmbedModalContent(bookingModal);

      const goBackBtn = bookingModal.querySelector('[data-go-back]');
      if(goBackBtn){
        goBackBtn.addEventListener('click', function() {
          addLoadingModal(bookingModal.querySelector('.modal-container'));
          loadDetailModal(experienceId, goBackBtn);
        });
      }

      enableAllBookingButtons();

      detachBookingModalPaymentClick(bookingModal);

      function onModalClick(e) {
        if((e.target.classList.contains('load-payment') || e.target.closest('.load-payment') !== null)
            || e.target.classList.contains('ticket-continue')
        ){
          detachBookingModalPaymentClick(bookingModal);

          addLoadingModal(bookingModal.querySelector('.modal-container'));

          window.setTimeout(() => {
            loadPaymentModal(experienceId);
          }, 1000);
        }
      }
      bookingModal[BOOKING_MODAL_PAYMENT_CLICK_KEY] = onModalClick;
      bookingModal.addEventListener('click', onModalClick);
      // bookingModal.querySelector('button[data-go-to-payment]').addEventListener('click', function() {
      //   loadPaymentModal(experienceId);
      // });
      // bookingModal.querySelector('button[data-go-back]').addEventListener('click', function() {
      //   loadDetailModal(experienceId, this);
      // });
    },  'GET', {}, {}, true, false);
  }

  function loadPaymentModal(experienceId) {
    const form = bookingModal.querySelector('#form-booking');

    const widgetWrapper = document.getElementById('widgetWrapper');
    if(widgetWrapper){
      var widgetId = widgetWrapper.dataset.widget;
    }

    let formData = new FormData(form);
    formData.append('widget_id', widgetId);

    ajax('/embed/newcart', function(res) {
      if(!res.data.success){
        Message.error(res.data.errorMessage);
        bookingModal.querySelector('.modal-container').classList.remove('loading-modal');

        detachBookingModalPaymentClick(bookingModal);
        function onRetryPaymentClick(e) {
          if(e.target.classList.contains('load-payment') || e.target.closest('.load-payment') !== null){
            detachBookingModalPaymentClick(bookingModal);

            addLoadingModal(bookingModal.querySelector('.modal-container'));
            window.setTimeout(() => {
              loadPaymentModal(experienceId);
            }, 1000);
          }
        }
        bookingModal[BOOKING_MODAL_PAYMENT_CLICK_KEY] = onRetryPaymentClick;
        bookingModal.addEventListener('click', onRetryPaymentClick);
        return;
      }

      if(!res.data.isFree){
        // then make request to get view
        ajax('/embed/payment/' + experienceId + '/' + res.data.cart.id + '?currency=' + widgetWrapper?.dataset.currencyIso + '&locale=' + widgetWrapper?.dataset.locale, function(data) {
          const paymentContent = paymentModal.querySelector('.modal-content');
          paymentContent.classList.remove('modal-content-fade-visible');
          paymentContent.innerHTML = data;
          paymentModal.querySelector('.modal-container').classList.remove('loading-modal');

          Modal.closeAllModals();
          const modalCloseButtons = paymentModal.querySelectorAll('.modal-content .modal-close');
          if(modalCloseButtons){
            modalCloseButtons.forEach(button => {
              button.addEventListener('click', Modal.closeAllModals);
            });
          }

          // load intl tel input
          const telInput = paymentModal.querySelector('input[name="phone"]');
          const iti = intlTelInput(telInput, {
            initialCountry: telInput.dataset.country,
            utilsScript: "//cdnjs.cloudflare.com/ajax/libs/intl-tel-input/16.0.4/js/utils.js"
          });
          telInput.addEventListener('change', function() {
            if(iti.isValidNumber()) {
              this.value = iti.getNumber();
            } else {
              this.value = '';
            }
          });

          initStripe();

          new Dob(paymentModal);
          initMelchiorInput(paymentModal);

          Modal.toggleModal('#payment-modal');
          revealEmbedModalContent(paymentModal);

          const goBackButtons = paymentModal.querySelectorAll('[data-go-back]');
          if(goBackButtons){
            goBackButtons.forEach((button) => {
              button.addEventListener('click', () => {
                addLoadingModal(paymentModal.querySelector('.modal-container'));

                loadBookingModal(experienceId);
              });
            });
          }

          const reservedSpotsCountdowns = document.querySelectorAll('.reserved-spots-countdown');
          if(reservedSpotsCountdowns){
            reservedSpotsCountdowns.forEach(countdown => {
              initCountDown(countdown, countdown.dataset.now, countdown.dataset.endTime);
            });
          }

          const backToExperiencesList = document.querySelectorAll('.close-modal');
          if(backToExperiencesList){}
          for (let i = 0; i < backToExperiencesList.length; i++) {
            backToExperiencesList[i].addEventListener('click', Modal.closeAllModals);
          }
        },  'GET', {}, {}, true, false);
      }
      else {
        ajax('/embed/free/' + experienceId + '?currency=' + widgetWrapper?.dataset.currencyIso + '&locale=' + widgetWrapper?.dataset.locale, function(data) {
          const freeContent = freeModal.querySelector('.modal-content');
          freeContent.classList.remove('modal-content-fade-visible');
          freeContent.innerHTML = data;
          freeModal.querySelector('.modal-container').classList.remove('loading-modal');
          Modal.closeAllModals();

          const closeModalTriggers = freeModal.querySelectorAll('.modal-content .modal-close');
          if(closeModalTriggers){
            closeModalTriggers.forEach((trigger) => {
              trigger.addEventListener('click', Modal.closeAllModals);
            });
          }

          // load intl tel input
          const telInput = freeModal.querySelector('input[name="phone"]');
          const iti = intlTelInput(telInput, {
            initialCountry: telInput.dataset.country,
            utilsScript: "//cdnjs.cloudflare.com/ajax/libs/intl-tel-input/16.0.4/js/utils.js"
          });
          telInput.addEventListener('change', function() {
            if(iti.isValidNumber()) {
              this.value = iti.getNumber();
            } else {
              this.value = '';
            }
          });

          new Dob(freeModal);
          initMelchiorInput(freeModal);

          const goBackButtons = freeModal.querySelectorAll('[data-go-back]');
          if(goBackButtons){
            goBackButtons.forEach((button) => {
              button.addEventListener('click', () => {
                addLoadingModal(freeModal.querySelector('.modal-container'));
                loadBookingModal(experienceId);
              });
            });
          }

          const reservedSpotsCountdowns = document.querySelectorAll('.reserved-spots-countdown');
          if(reservedSpotsCountdowns){
            reservedSpotsCountdowns.forEach(countdown => {
              initCountDown(countdown, countdown.dataset.now, countdown.dataset.endTime);
            });
          }

          const backToExperiencesList = document.querySelectorAll('.close-modal');
          if(backToExperiencesList){}
          for (let i = 0; i < backToExperiencesList.length; i++) {
            backToExperiencesList[i].addEventListener('click', Modal.closeAllModals);
          }

          const form = freeModal.querySelector('form');
          const confirmationScreen = freeModal.querySelector('.confirmation');
          const topBookingInformation = freeModal.querySelector('#top-booking-informations');
          const freeFormDiv = freeModal.querySelector('#freeForm');
          const partnerTopBar = document.getElementById('partner-top-bar')
          if(form && confirmationScreen && topBookingInformation && freeFormDiv){
            const submitButton = form.querySelector("button[type='submit']");
            form.addEventListener('submit', (e) => {
              e.preventDefault();
              if(submitButton) submitButton.disabled = true;

              let freeFormData = new FormData(form);
              ajax(form.action, function () {
                confirmationScreen.classList.remove('hidden');
                if(partnerTopBar) partnerTopBar.classList.add('hidden');

                // hide elements that should be hidden
                const elementsToHide = document.querySelectorAll('.hide-on-checkout-success');
                if(elementsToHide){
                  elementsToHide.forEach(element => {
                    element.classList.add('hidden');
                    element.classList.add('lg:hidden');
                  });
                }

                const showOnCheckoutSuccess = document.querySelectorAll('.show-on-checkout-success');
                if(showOnCheckoutSuccess){
                  showOnCheckoutSuccess.forEach(element => {
                    element.classList.remove('hidden');
                  });
                }

                // and narrow the modal container to make a nice animation
                // const modalContainer = form.closest('.modal-container');
                // const modalContent = form.closest('.modal-content');
                // if(modalContainer && modalContent) {
                  // modalContainer.classList.remove('max-w-8xl');
                  // modalContainer.classList.add('max-w-2xl');
                  // modalContent.classList.remove('max-w-8xl');
                  // modalContent.classList.add('max-w-2xl');
                // }

                topBookingInformation.classList.add('hidden');
                freeFormDiv.classList.add('hidden');

                const bookingHeldElts = document.querySelectorAll('.booking-held-wrapper');
                if(bookingHeldElts) bookingHeldElts.forEach(elt => elt.classList.add('hidden'));

                clearAllReservedSpotsCountdowns();

                scrollEmbedBookingLayoutToTop();
              },
               'POST', freeFormData, {
              "X-CSRF-Token": document.querySelector('meta[name="csrfToken"]')?.content
              }, true, true);
            });
          }

          Modal.toggleModal('#free-modal');
          revealEmbedModalContent(freeModal);
        },  'GET', {}, {}, true, false);
      }

    }, 'POST', formData, {}, true, true);
  }

  function setCardBookingButtonLoading(detailTrigger) {
    const experienceCard = detailTrigger.closest('article');
    if (!experienceCard) {
      return;
    }

    const bookingButton = experienceCard.querySelector('button[data-open-booking]');
    if (!bookingButton) {
      return;
    }

    bookingButton.classList.add('loading');
    bookingButton.disabled = true;
  }

  window.addEventListener('click', (e) => {
    const bookingButton = e.target.closest('[data-open-booking]');
    const detailButton = e.target.closest('[data-open-detail]');
    const trigger = bookingButton || detailButton;

    if (!trigger) {
      return;
    }

    if (trigger.tagName === 'A') {
      e.preventDefault();
    }

    if (detailButton) {
      setCardBookingButtonLoading(detailButton);
    }

    trigger.classList.add('loading');
    trigger.disabled = true;

    document.querySelectorAll('.modal-content.modal-content-fade-visible').forEach((el) => {
      el.classList.remove('modal-content-fade-visible');
    });

    if (!trigger.classList.contains('openOnLoad')) {
      if (bookingButton) {
        loadBookingModal(bookingButton.dataset.experienceId);
      }
      else {
        loadDetailModal(detailButton.dataset.experienceId, detailButton);
      }
    }
    else {
      loadBookingModal(trigger.dataset.experienceId);
      trigger.classList.remove('openOnLoad');
    }
  });

  const openOnLoadButton = document.querySelector('button[data-open-booking].openOnLoad');
  if(openOnLoadButton){
    // openOnLoadButton.dispatchEvent(new Event('click'));
    openOnLoadButton.classList.add('loading');
    openOnLoadButton.disabled = true;

    loadBookingModal(openOnLoadButton.dataset.experienceId);
    openOnLoadButton.classList.remove('openOnLoad');
  }

  const singleExpEmbedWidget = document.getElementById('open-on-load');
  if(singleExpEmbedWidget){
    loadBookingModal(singleExpEmbedWidget.dataset.experienceId);
  }

  Modal.bindAllModals();
}

export { initWidgetBookingModals }
